module.exports = "<div class=\"col-sm-8 col-sm-offset-2\"> <h4>Your shop messages</h4> <div class=\"divider small tight transparent\"></div> <ink-message-templates message-templates-owner=$ctrl.messageTemplatesOwner> </ink-message-templates> </div> ";


//////////////////
// WEBPACK FOOTER
// ./components/shop/messages/shop-messages-route.template.html
// module id = ./components/shop/messages/shop-messages-route.template.html
// module chunks = 0